// extracted by mini-css-extract-plugin
export default {"aboutBylawsContainerBox":"styles_aboutBylawsContainerBox__Vvqw-"};